import React from 'react';
import styles from '../styles/interactive-docs.module.css';
import MarkdownRenderer from './MarkdownRenderer';
import DrawingSandbox from './sandbox/DrawingSandbox';
import MeasurementSandbox from './sandbox/MeasurementSandbox';

const DocsContent = ({ item, categoryTitle, prevItem, nextItem, onSelectItem }) => {
    if (!item) {
        return (
            <main className={styles.mainContent}>
                <div className={styles.contentWrapper}>
                    <p>Выберите раздел в меню слева для просмотра руководства.</p>
                </div>
            </main>
        );
    }

    const IconComponent = item.icon;

    // Рендер песочницы при обнаружении тега {{sandbox:...}} в Markdown
    const renderSandbox = (type) => {
        const targetType = type || item.sandboxType;
        if (targetType === 'measurements' || targetType?.startsWith('measure-')) {
            return <MeasurementSandbox key={type} />;
        }
        return <DrawingSandbox key={type} initialTool={targetType} />;
    };

    const hasSandboxTagInMarkdown = item.markdown && item.markdown.includes('{{sandbox:');

    const handleNavigate = (itemId) => {
        if (onSelectItem) {
            onSelectItem(itemId);
            // Прокрутка наверх контента
            const mainEl = document.querySelector(`.${styles.mainContent}`);
            if (mainEl) {
                mainEl.scrollTo({ top: 0, behavior: 'smooth' });
            }
        }
    };

    return (
        <main className={styles.mainContent}>
            <div className={styles.contentWrapper}>
                {/* Заголовок статьи */}
                <header className={styles.articleHeader}>
                    <div className={styles.breadcrumb}>
                        <span>Документация</span>
                        <span>/</span>
                        <span>{categoryTitle}</span>
                        <span>/</span>
                        <span>{item.title}</span>
                    </div>

                    <h1 className={styles.articleTitle}>
                        {IconComponent && <IconComponent size={22} />}
                        <span>{item.title}</span>
                    </h1>

                    {item.summary && (
                        <p className={styles.articleSummary}>{item.summary}</p>
                    )}
                </header>

                {/* Анимация/GIF демонстрация работы инструмента вверху статьи */}
                {item.gif && (
                    <div style={{
                        marginBottom: '20px',
                        padding: '12px',
                        background: 'var(--color-surface, #ffffff)',
                        borderRadius: '6px',
                        border: '1px solid var(--color-border, #e2e8f0)',
                        textAlign: 'center'
                    }}>
                        <img
                            src={item.gif}
                            alt={item.title}
                            style={{
                                maxWidth: '100%',
                                maxHeight: '320px',
                                borderRadius: '4px',
                                border: '1px solid var(--color-border, #e2e8f0)',
                                objectFit: 'contain'
                            }}
                        />
                    </div>
                )}

                {/* Если песочница задана, но не встроена в Markdown явным тегом */}
                {item.sandboxType && !hasSandboxTagInMarkdown && (
                    item.sandboxType === 'measurements' || item.sandboxType?.startsWith('measure-')
                        ? <MeasurementSandbox />
                        : <DrawingSandbox initialTool={item.sandboxType} />
                )}

                {/* Рендеринг структурированного Markdown */}
                {item.markdown && (
                    <MarkdownRenderer
                        markdown={item.markdown}
                        renderSandbox={renderSandbox}
                    />
                )}

                {/* Legacy/Дополнительный JSX контент, если есть */}
                {item.content && (
                    <div style={{ marginTop: '16px' }}>
                        {item.content}
                    </div>
                )}

                {/* Нижняя навигация: Назад / Далее */}
                {(prevItem || nextItem) && (
                    <nav className={styles.paginationWrapper} aria-label="Навигация по статьям">
                        {prevItem ? (
                            <button
                                type="button"
                                className={styles.paginationBtn}
                                onClick={() => handleNavigate(prevItem.id)}
                                title={`Перейти к: ${prevItem.title}`}
                            >
                                <span className={styles.paginationSublabel}>← Назад</span>
                                <span className={styles.paginationTitle}>{prevItem.title}</span>
                            </button>
                        ) : (
                            <div />
                        )}

                        {nextItem && (
                            <button
                                type="button"
                                className={`${styles.paginationBtn} ${styles.paginationBtnNext}`}
                                onClick={() => handleNavigate(nextItem.id)}
                                title={`Перейти к: ${nextItem.title}`}
                            >
                                <span className={styles.paginationSublabel}>Далее →</span>
                                <span className={styles.paginationTitle}>{nextItem.title}</span>
                            </button>
                        )}
                    </nav>
                )}
            </div>
        </main>
    );
};

export default DocsContent;
